import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './index.less';

interface RankedAddress {
  experience: number;
  id: number;
  hash: string;
  customName: string;
  ranking: number;
  level: number;
  militaryRank: string;
  teamCard: {
    teamName: string;
    englishName: string;
    logo: string;
  };
}

const RankingPage: React.FC = () => {
  const [rankedAddresses, setRankedAddresses] = useState<RankedAddress[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRanking();
  }, []);

  const fetchRanking = async () => {
    try {
      const response = await axios.get('/api/v1/backroomsteamcard/ranking');
      setRankedAddresses(response.data);
    } catch (error) {
      console.error('Error fetching ranking:', error);
    } finally {
      setLoading(false);
    }
  };

  const getRankClass = (index: number) => {
    if (index === 0) return 'rank-1';
    if (index === 1) return 'rank-2';
    if (index === 2) return 'rank-3';
    return 'rank-other';
  };

  return (
    <div className="ranking-page">
      <div className="back-button" onClick={() => window.history.back()}>
        &lt; 返回
      </div>

      <div className="ranking-list">
        {rankedAddresses.map((address, index) => (
          <div key={address.id} className="ranking-item">
            <div className={`rank-number ${getRankClass(index)}`}>{index + 1}</div>
            <div className="rank-info">
              <div className="team-name">{address.customName}</div>
              <div className="rank-info">
                团队：<span className="military-rank">{address.teamCard.teamName}</span>
              </div>
              <div className="rank-info">
                军衔：<span className="military-rank">{address.militaryRank}</span>
              </div>

              <div className="address-info">
                <span className="">等级：Lv.{address.level}</span>
                <span className="">(经验值{address.experience})</span>
              </div>

            </div>
            <div className="logo">
              <img src={address.teamCard.logo} alt={address.teamCard.teamName} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RankingPage; 